<template>
  <div
    class="page_container addCommondity"
    v-loading="loading"
    element-loading-text="提交中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/manage' }"
          >促销优惠&市场活动</el-breadcrumb-item
        >
       <el-breadcrumb-item :to="{ path: '/ShopIndex' }"
          >市场活动管理</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/ShopIndex/shopBanner' }">活动banner</el-breadcrumb-item>
        <el-breadcrumb-item>{{ formData.id == "" ? "新增活动banner" : "活动banner设置" }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- 主要内容 start -->
    <div class="form_container">
      <h1>{{ formData.id == "" ? "新增活动banner" : "活动banner设置" }}</h1>
      <div class="content_wrap flex-rowl">
        <div class="form_wrap">
          <div class="block">
            <p><span class="mark">*</span>banner图</p>
            <p class="red">JPG或者PNG格式，尺寸比例为500*500像素</p>
            <div
              class="upload_box"
              @mouseenter="enter(1)"
              @mouseleave="creenIndex = ''"
            >
              <el-upload
                action
                list-type="picture-card"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :http-request="beforeAvatarUpload"
              >
                <div v-if="formData.banner">
                  <img :src="baseUrl + formData.banner" class="avatar" />
                  <div
                    class="el-upload-list__item-actions flex-rowc"
                    v-show="creenIndex == 1"
                  >
                    <span
                      @click.stop="
                        handlePictureCardPreview(baseUrl + formData.banner, 1)
                      "
                      ><i class="iconfont icon-fangda"></i
                    ></span>
                    <span @click.stop="handleRemove(1)"
                      ><i class="iconfont icon-icon_shanchu-"></i
                    ></span>
                  </div>
                </div>

                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </div>
          </div>
          <div class="block">
            <p><span class="mark">*</span>奖项等级：</p>
            <div class="select_box">
              <el-input
                v-model="formData.levelid"
                placeholder="请输入奖项等级"
              ></el-input>
            </div>
          </div>
          <div class="block">
            <p><span class="mark">*</span>商品：</p>
            <div class="select_box">
              <el-input
                v-model="formData.goodsid"
                placeholder="请输入商品"
              ></el-input>
            </div>
          </div>
          <div class="block">
            <p>排序：</p>
            <div class="select_box">
              <el-input
                v-model="formData.sortno"
                placeholder="请输入排序"
              ></el-input>
            </div>
          </div>
        </div>
        <div class="tip_wrap"></div>
      </div>
    </div>
    <div class="form_footer flex-rowl">
      <div class="btn" @click="query">确认</div>
      <div class="return_txt" @click="handleReturn">←返回</div>
    </div>
    <!-- 主要内容 end -->

    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import {
  uploadPosterImage,
  encryptstringview,
} from "../../api/api";
import {
  getActivityBannerDetail,
  editActivityBanner,
  addActivityBanner,
} from "../../api/shop";
export default {
  name: "shopBannerDetail",
  data() {
    return {
      baseUrl: process.env.VUE_APP_IMG_BASE_API,
      loading: false,
      formData: {
        id: "",
        actid: "",
        banner: "",
        levelid: '',
        goodsid: '',
        sortno: '',
      },
      creenIndex: 1,
      dialogImageUrl: "",
      dialogVisible: false,
    };
  },
  created() {
    let { routerList, OPENID } = this.$store.state;
    let { name } = this.$route;
    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id, actid } = JSON.parse(res.jsondata);
        this.formData.actid = actid;
        this.formData.id = id;
        if (id != "") {
          this.getActivityBannerDetail(id);
        }
      } else {
        this.$router.back();
      }
    },

    // 获取活动详情
    getActivityBannerDetail(id) {
      getActivityBannerDetail({ id }).then((res) => {
        this.formData.actid = res.actid;
        this.formData.banner = res.banner;
        this.formData.levelid = res.levelid;
        this.formData.goodsid = res.goodsid;
        this.formData.sortno = res.sortno;
      });
    },  

    // 移出图片
    handleRemove(isType) {
      if (isType == 1) {
        this.formData.banner = "";
      }
    },
    // 大图预览
    handlePictureCardPreview(url) {
      this.dialogImageUrl = url;
      this.dialogVisible = true;
    },
    // 移入图片区域
    enter(type) {
      this.creenIndex = type;
    },

    handleAvatarSuccess(file) {
      const isJPG =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg";
      if (!isJPG) {
        this.$message.error("缩略图只能是图片");
      }
    },
    beforeAvatarUpload(e) {
      let { creenIndex } = this;
      var formData = new FormData();
      formData.append("imgfile", e.file);
      this.loading = true;
      uploadPosterImage(formData).then((res) => {
        if (res.result) {
          this.loading = false;
          if (creenIndex == 1) {
            this.formData.banner = res.code;
          }
        } else {
          this.loading = false;
          this.$message.error(res.message || "服务器报错，请稍后～");
        }
      });
    },

    // 返回上一页
    handleReturn() {
      history.back();
    },

    // 提交数据
    query() {
      let { formData } = this;
      if (formData.sortno == "") {
        this.$message.warning("请上传banner");
        return;
      }
      if (formData.levelid == "") {
        this.$message.warning("请输入奖项等级");
        return;
      }
      if (formData.goodsid == "") {
        this.$message.warning("请输入商品");
        return;
      }
      this.loading = true;

      if (formData.id == "") {
        this.loading = true;
        addActivityBanner(formData).then((res) => {
          if (res.result) {
            setTimeout(() => {
              this.loading = false;
              this.$router.back();
            }, 500);
          } else {
            this.loading = false;
            this.$message.error(res.message || "服务器报错，请稍后～");
          }
        });
      } else {
        this.loading = true;
        editActivityBanner(formData).then((res) => {
          if (res.result) {
            setTimeout(() => {
              this.loading = false;
              this.$message.success(res.message);
            }, 500);
          } else {
            this.loading = false;
            this.$message.error(res.message || "服务器报错，请稍后～");
          }
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.addCommondity {
  .form_container {
    h1 {
      font-size: 20px;
      color: #404d6c;
      margin-bottom: 28px;
    }
    .content_wrap {
      align-items: flex-start;
      .form_wrap {
        flex: 1;
        margin-right: 100px;
        .block {
          margin-bottom: 45px;
          .input_box {
            margin-bottom: 20px;
          }
        }
      }
      .tip_wrap {
        flex: 1;
      }
      p {
        font-size: 18px;
        color: #6e6e6e;
        margin-bottom: 8px;
        &.red {
          font-size: 16px;
          color: #ff0012;
          line-height: 26px;
          // margin-bottom: 0;
        }
        .mark {
          color: #ff0012;
          font-size: 14px;
          margin-right: 4px;
        }
      }
    }
  }
  .custom_wrap {
    .diaog_head {
      height: 80px;
      h1 {
        font-size: 18px;
        color: #6e6e6e;
      }
      p {
        font-size: 14px;
        color: #ff0012;
        margin: 10px 0 8px;
      }
    }
    .diaog_body {
      // height: calc(68vh - 160px);
      .radio_wrap {
        .radio_group {
          flex-wrap: wrap;
          .radio_item {
            margin-right: 80px;
            font-size: 14px;
            color: #6e6e6e;
            margin-bottom: 20px;
            cursor: pointer;
            .iconfont {
              font-size: 22px;
              margin-right: 5px;
              color: #a5a5a5;
              &.icon-danxuanyixuan1 {
                color: #ea4e4e;
              }
            }
          }
        }
      }
    }
    .dialog_footer {
      .link {
        a {
          font-size: 16px;
          color: #fe3c46;
        }
      }
    }
  }
}
</style>